import { Box, buttonClasses, FormControl, styled, Typography } from '@mui/material';
import { IconCross } from 'assets/img';
import { StyledFormInputLabel } from 'public/components/common/forms/form-input-label/form-input-label';
import { StyledFormHelperText } from 'public/components/common/forms/form-helper-text/form-helper-text';
import { FilePickerProps } from './types';
import { getSelectedFileNames } from './utils/get-selected-file-names';
import { hasSelectedFiles } from './utils/has-selected-files';
import { PublicButton } from '../../../common/button/button';

export const CertificateFilePicker = ({
  name,
  title,
  fileType,
  disabled,
  label,
  selectedFile,
  handleFileChange,
  clearSelectedFile,
  error,
  required,
}: FilePickerProps) => {
  return (
    <FormControl variant="filled" fullWidth>
      <StyledFormInputLabel required={required} id={`${label}-label`}>
        {label}
      </StyledFormInputLabel>
      <StyledPublicButton color="secondary" component="label" disabled={disabled}>
        {title}
        <input
          name={name}
          type="file"
          multiple
          accept={fileType}
          hidden
          onChange={handleFileChange}
          key={hasSelectedFiles(selectedFile) ? getSelectedFileNames(selectedFile) : 'empty'}
        />
      </StyledPublicButton>
      {error ? <StyledFormHelperText>{error}</StyledFormHelperText> : null}
      {hasSelectedFiles(selectedFile) ? (
        <FileInfoWrapper>
          <FileNameTypography title={getSelectedFileNames(selectedFile)}>
            {getSelectedFileNames(selectedFile)}
          </FileNameTypography>

          <ClearButton
            type="button"
            data-testid="clear-file-picker-button"
            onClick={clearSelectedFile}
          >
            <StyledIconCross />
          </ClearButton>
        </FileInfoWrapper>
      ) : null}
    </FormControl>
  );
};

const FileInfoWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(2),
}));

const FileNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(14),
  color: theme.palette.text.secondary,
}));

const ClearButton = styled('button')(({ theme }) => ({
  background: 'none',
  border: 'none',
  padding: theme.spacing(1),
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledIconCross = styled(IconCross)(({ theme }) => ({
  display: 'block',
  width: theme.spacing(4),
  height: theme.spacing(4),
}));

const StyledPublicButton = styled(PublicButton)(({ theme }) => ({
  [`&.${buttonClasses.root}`]: {
    padding: theme.spacing(2, 6),
    marginBottom: theme.spacing(2),
  },
}));
